import * as React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Screen-with-return-arrow glyph for the History sidebar item, exported from
 * the design's rail component. Built on MUI's `SvgIcon` so it takes the nav's
 * `sx`/`fontSize`/`color` props like the rest; the paths use `currentColor`, so
 * the sidebar tints it via `palette.icon` / `palette.iconActive`.
 *
 * The export is a 12-unit square. It is scaled to 16 and inset by 1 inside an
 * 18×18 viewBox for the same reason `GridLayoutIcon` documents: the sidebar
 * renders nav icons at `fontSize: 18`, and the 1-unit margin lands the ink at
 * the design's 16px instead of filling all 18 — without it these glyphs read
 * noticeably larger than their MUI neighbours.
 */
const HistoryIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <g transform="translate(1 1) scale(1.33333)" fill="currentColor">
      <path d="M11.25 0H1.5C1.05 0 0.75 0.3 0.75 0.75V6H2.25V1.5H10.5V9H3V7.5L0 9.75L3 12V10.5H11.25C11.7 10.5 12 10.2 12 9.75V0.75C12 0.3 11.7 0 11.25 0Z" />
      <path d="M5.25 3V6H8.25V4.5H6.75V3H5.25Z" />
    </g>
  </SvgIcon>
);

export default HistoryIcon;
